import './Landingpage.css';

export default function Landingpage(){
    return <div className= "Landingpage">
        <h2 className = "Heading-Developer">Hi! My name is</h2>
        <h1 className = "Heading">Noah Aldhous</h1>
        <p className = "Body-Text">I am a full-stack developer, <br/> and recent graduate of the <br/> <a className = "SoC-Link" href = "https://www.schoolofcode.co.uk/" target = "_blank" rel="noreferrer">School of Code</a>. <br/> I love creative design, <br/> and technical problem-solving.</p>   
    </div>
}